<template>
  <div class="beij">
    <div class="dax"></div>
    <i-col span="6" offset="9">
      <Card dis-hover class="colors">
        <!-- <img src="../assets/login.png" > -->
        <div slot="title">
          <img
            src="../assets/logo-black.png"
            style="display: block; height: 30px"
          />
        </div>
        <i-form :label-width="100" class="kuan">
          <Form-item label="账号" prop="age">
            <el-input size="mini" type="text" v-model="formCustom.user" number clearable />
          </Form-item>
          <Form-item label="密码" prop="passwd">
            <el-input size="mini" type="password" v-model="formCustom.passwd" clearable @keyup.enter.native="handleSubmit()"/>
          </Form-item>
          <!-- <Form-item label="验证码" prop="passwd" class="yzm">
            <div class="yzms">
              <i-input type="text" v-model="formCustom.yzms"></i-input>
              <i-button type="dashed" @click="sjs">{{
                formCustom.yzm
              }}</i-button>
            </div>
          </Form-item> -->
          <Form-item class="anniu">
            <i-button
              type="primary"
              @click="handleSubmit()"
              >立即登录</i-button
            >
          </Form-item>
        </i-form>
      </Card>
    </i-col>
    <Modal
      v-model="modal1add"
      ok-text="保存"
      width="460"
      title="修改密码"
      @on-ok="ok"
    >
      <el-form label-width="80px">
        <el-form-item label="密码">
          <el-input v-model="pwd"></el-input>
        </el-form-item>
      </el-form>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modal1add: false,
      pwd: "",
      formCustom: {
        keyza: "zajdfsdjkadkaskolSJDKS652..sadasjDADEza",
        passwd: "",
        user: "",
        yzms: "",
        yzm: "yzm12",
      },
    };
  },
  created() {

  },
  mounted() {
    this.formCustom.user = window.localStorage.getItem("login");
  },

  methods: {
    handleSubmit() {
      if (this.formCustom.user == "") {
        this.$Message.error("账号不能为空!");
      } else if (this.formCustom.passwd == "") {
        this.$Message.error("密码不能为空!");
      } else {
        this.$myhttp
          .post("admin/userLogin?shuanx=33", this.formCustom, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            console.log(backdata.data);
            if (backdata.data[0] == 1) {
              window.localStorage.setItem("token", backdata.data[2]);
              window.localStorage.setItem("login", this.formCustom.user);
              window.localStorage.setItem("oa_user_id", backdata.data[3]);
              this.$socket.socket=null;
              this.$socket.socket=this.$socket.Socket.reSocket();
              this.$auth.initUser();
              this.$Message.success(backdata.data[1]);
              if (backdata.data[4] == 1) {
                this.modal1add = true;
              } else {
                this.$router.push({ name: "BigScreen" });
              }
            }
            if (backdata.data[0] == 2) {
              this.$Message.error(backdata.data[1]);
            }
          });
      }
    },
    sjs() {
      //验证码生成
      this.$myhttp
        .get("admin/yzm?shuanx=33", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          //console.log(backdata.data);
          this.formCustom.yzm = backdata.data;
        });
    },
    //保存密码
    ok() {
      if (this.pwd == "") {
        this.$Message.error("保存密码不能为空!");
        return false;
      }
      this.$Loading.start();
      this.$myhttp
        .post(
          "admin/userpwdupdate",
          { pwd: this.pwd },
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((backdata) => {
          // 异步执行成功后
          this.$Loading.finish();
          this.$Message.success("修改成功");
          this.pwd = "";
          this.$router.push({ name: "BigScreen" });
        });
    },
  },
};
</script>

<style scoped>
.dax {
  margin-top: 10%;
  background-color: rgb(233, 237, 245);
}
.beij {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgb(233, 237, 245);
}
.kuan {
  width: 320px;
}
.yzm {
  width: 320px;
}
.yzms {
  display: flex;
}
.kuand {
  width: 100px;
}
.beijs {
  background-color: rgb(233, 237, 245);
}
.colors {
  width: 430px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue